import { useState, useEffect } from "react";
import Nav from "@/components/sections/Nav";
import PromoBanner from "@/components/sections/PromoBanner";
import Hero from "@/components/sections/Hero";
import ConversionBanner from "@/components/sections/ConversionBanner";
import HalloweenSpecial from "@/components/sections/HalloweenSpecial";
import Services from "@/components/sections/Services";
import ServicesDetail from "@/components/sections/ServicesDetail";
import Gallery from "@/components/sections/Gallery";
import EventReady from "@/components/sections/EventReady";
import KeepAustinCut from "@/components/sections/KeepAustinCut";
import SeasonalTip from "@/components/sections/SeasonalTip";
import TipSubscribe from "@/components/sections/TipSubscribe";
import Testimonials from "@/components/sections/Testimonials";
import BattleBanner from "@/components/sections/BattleBanner";
import PricingBooking from "@/components/sections/PricingBooking";
import About from "@/components/sections/About";
import CEO from "@/components/sections/CEO";
import Footer from "@/components/sections/Footer";
import MusicToggle from "@/components/sections/MusicToggle";

export default function Home() {
  const [promoOpen, setPromoOpen] = useState(true);

  useEffect(() => {
    try {
      if (localStorage.getItem("ironclad-promo-dismissed-v3") === "true") {
        setPromoOpen(false);
      }
    } catch {}
  }, []);

  return (
    <div data-testid="home-page" className="bg-background text-foreground">
      {promoOpen && <PromoBanner onDismiss={() => setPromoOpen(false)} />}
      <Nav offsetTop={promoOpen} />
      <MusicToggle />
      <main>
        <HalloweenSpecial />
        <Hero />
        <ConversionBanner />
        <Services />
        <ServicesDetail />
        <Gallery />
        <EventReady />
        <KeepAustinCut />
        <SeasonalTip />
        <TipSubscribe />
        <About />
        <CEO />
        <Testimonials />
        <BattleBanner />
        <PricingBooking />
      </main>
      <Footer />
    </div>
  );
}
